/**
 * @generated SignedSource<<35683f516c11cbc2072974f242b7b608>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type preconfiguredModelsQuery$variables = {};
export type preconfiguredModelsQuery$data = {
  readonly preconfiguredModels: ReadonlyArray<{
    readonly compatiblePreconfiguredSources: ReadonlyArray<string | null>;
    readonly displayName: string;
    readonly name: string;
    readonly provider: string;
    readonly revisions: ReadonlyArray<{
      readonly tables: ReadonlyArray<string>;
    }>;
    readonly stableVersion: number | null;
  }>;
};
export type preconfiguredModelsQuery = {
  response: preconfiguredModelsQuery$data;
  variables: preconfiguredModelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PreconfiguredModel",
    "kind": "LinkedField",
    "name": "preconfiguredModels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "compatiblePreconfiguredSources",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stableVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Revision",
        "kind": "LinkedField",
        "name": "revisions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tables",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "preconfiguredModelsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "preconfiguredModelsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "aae0ef9bb7931edf91b9582d66254342",
    "id": null,
    "metadata": {},
    "name": "preconfiguredModelsQuery",
    "operationKind": "query",
    "text": "query preconfiguredModelsQuery {\n  preconfiguredModels {\n    name\n    provider\n    displayName\n    compatiblePreconfiguredSources\n    stableVersion\n    revisions {\n      tables\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dea7be2cfd3c52ff29029b9abddbf8ee";

export default node;
